import { all, fork } from 'redux-saga/effects';

import github from './github';
import user from './user';
import app from './app';

/**
 * rootSaga
 */
export default function* root() {
  yield all([
    fork(github),
    fork(user),
    fork(app),
  ]);
}



// WEBPACK FOOTER //
// ./scripts/sagas/index.js